// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "GalleryPictureItem-module--wrapper--P1j3u";
export var rounded = "GalleryPictureItem-module--rounded--Sld75";
export var description = "GalleryPictureItem-module--description--Hsoi5";